<div #chartContainer style="text-align: center; min-height: 100px;" id="chart-container'">
  <!-- <h2 style="font-size: 1em;">Timeline In/Out Records</h2> -->
  <google-chart
  #chart
  style="width: 98%; margin: 0px auto; border-radius: 5px;"
  [type]="changingChart.type"
  [data]="changingChart.data"
  [columns]="changingChart.columns"
  [options]="chartOptions"
  (ready)="onChartReady(chartContainer)"
>
</google-chart>
<p class="chart-def">
  <span>
    <ion-icon name="ellipse" style="color: #7D7A7A"></ion-icon>&nbsp;
    Shift
  </span>
  <span>
    <ion-icon name="ellipse" style="color: #4caf50"></ion-icon>&nbsp;
    Inside
  </span>
  <span>
    <ion-icon name="ellipse"  style="color: #f44336"></ion-icon>&nbsp;
    Outside
  </span>
</p>
</div>